<template>
  <div id="app">
    <transition name="el-zoom-in-center">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
};
</script>

<style>
html,
body,
#app,
.el-container {
  margin: 0;
  padding: 0;
  background-color: #ebeff0;
  height: 100%;
}
#app {
  font-family: "Microsoft YaHei", Lato, Helvetica, Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.el-cascader-menu__item {
  font-size: 12px;
  padding: 8px 10px;
}
.el-message {
  min-width: 100px;
}
.caption {
  font-size: 14px;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #409eff;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #409eff;
}
.el-tooltip__popper {
  background: #409eff !important;
}
::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}

/* 滚动条有滑块的轨道部分 */
::-webkit-scrollbar-track-piece {
  background-color: transparent;
  border-radius: 5px;
}

/* 滚动条滑块(竖向:vertical 横向:horizontal) */
::-webkit-scrollbar-thumb {
  cursor: pointer;
  background-color: rgba(144, 147, 153, .3);
  border-radius: 5px;
}

/* 滚动条滑块hover */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, .3);
}

/* 同时有垂直和水平滚动条时交汇的部分 */
::-webkit-scrollbar-corner {
  display: block;
  /* 修复交汇时出现的白块 */
}
</style>
